<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      :loading="loading"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :checkbox-config="{
        highlight: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
            v-if="disabled"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFromDialog', {
                  type: 'detail',
                  code: row.shipmentDocCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFromDialog', {
                  type: 'edit',
                  code: row.shipmentDocCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.shipmentDocCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: {},
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    orderInspectionCode: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    getCheckboxRecords(selectType = 'row') {
      const reserveRecords = this.$refs.vxeGrid.getCheckboxReserveRecords()
      const records = this.$refs.vxeGrid.getCheckboxRecords()
      const totCount = reserveRecords.length + records.length
      if (!totCount) {
        this.$message.warning('请选择需要批量处理的单据')
        return false
      }
      if (totCount > 20) {
        this.$message.warning(
          this.$l('INDEX.tips_question_max_select_rows') || '最多可选择20行！'
        )
        return false
      }
      const data = records.concat(reserveRecords)
      if (!data) return
      switch (selectType) {
        case 'code':
          return data.map((item) => item.shipmentDocCode)
        case 'row':
          return data
      }
    },
    clearCheckboxRow() {
      this.$refs.vxeGrid.clearCheckboxRow()
      this.$refs.vxeGrid.clearCheckboxReserve()
    },
    del(shipmentDocCode) {
      this.$emit('batchDel', [shipmentDocCode])
    },
  },
}
</script>
